import React, { useState, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import ActionModalBar from '../../../../../../../../../../components_v1/Actions/ActionModalBar';
import InputSelect from '../../../../../../../../../../components_v1/Forms/InputSelect';
import SimpleModal from '../../../../../../../../../../components_v1/Structure/Modals/SimpleModal';
import DisplayText from '../../../../../../../../../../components_v1/Texts/DisplayText';
import { onGetFormData, onInitForm, isFormValid, onSetErrorsToForm } from '../../../../../../../../../../shared/utility';
import { catalogs } from '../../../../../../../../../../texts/esp/catalogs';

const useStyles = makeStyles(theme => ({
  form: {
    paddingTop: 32,
    paddingBottom: 32
  }
}))

const EditFiscalModal = ({ id, open, onClose, init_data, onUpdateCompleted }) => {

  const classes = useStyles()

  const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {

    let _form = JSON.parse(JSON.stringify(formData))
    if (init_data) {
      _form = onInitForm(_form, init_data)
    }
    setForm(_form)
    if (!open) { setError(''); setLoading(false); }

  }, [open])

  const onChange = (data) => {
    let temp = { ...form }
    const id = data.config.id
    temp[id] = { ...data }
    setForm(temp)
  }

  const onSubmit = async () => {

    const errors = isFormValid(form)
    /// Check if the form is valid
    if (errors && errors.length) {
      const new_form = onSetErrorsToForm(form, errors)
      setForm(new_form)
      setError('Llene los campos faltantes')
      return
    }

    //Extract data
    let data2send = onGetFormData(form)
    //Send data
    setLoading(true)
    try {
      await onUpdateCompleted(data2send)
    } catch (error) {
      console.log(error)
      setError('Hubo un error')
    }
    setLoading(false)
  }


  return (
    <SimpleModal open={open} onClose={onClose} maxWidth='md'>
      <div>
        <DisplayText variant='h6' color='primary' style={{ fontWeight: 500 }}>Información del negocio</DisplayText>
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <InputSelect data={form.accounting_method_id} onChange={onChange} />
            </Grid>
            <Grid item xs={12}>
              <ActionModalBar btnLabel='Guardar' loading={loading} error={error} onSubmit={onSubmit} />
            </Grid>
          </Grid>
        </div>
      </div>
    </SimpleModal>
  );
}

export default EditFiscalModal;

const formData = {
  accounting_method_id: {
    value: null,
    error: false,
    isVisited: false,
    isRequired: false,
    isValid: false,
    options: [...catalogs.accounting_methods],
    config: {
      id: 'accounting_method_id',
      type: 'simple_select',
      fullWidth: true,
      label: 'Método de pago de impuestos',
      placeholder: 'Ingrese un texto'
    },
    rules: {
      type: 'none',
    }
  },
}